import _sfc_main from './SearchGreyM.vue2.mjs';
import _export_sfc from '../../_virtual/_plugin-vue_export-helper.mjs';

var TvbSearchGreyMIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["__file", "SearchGreyM.vue"]]);

export { TvbSearchGreyMIcon as default };
//# sourceMappingURL=SearchGreyM.vue.mjs.map
